// jQuery компонент для выбора диапазона чисел.
import moment from 'moment';

function NumberRangePicker($parent, options) {
    var self = this;

    this._init = function () {
        self.$picker = null;                // Элемент содержащий виджет с пикером
        self.range = options.range || null; // Последний успешно выбранный диапазон
        self.currentRangeStart = null;      // В данный момент выбранное пользователем начало диапазона
        self.$lastHoveredItem = null;       // Последний наведенный .nrp-item

        // Находится ли диапазон в процессе выбора пользователем?
        Object.defineProperty(self, 'selecting', {
            get: function () { return self.currentRangeStart !== null; }
        });

        $parent.on('click', self.toggle);
    };

    this.show = function (raiseEvent) {
        self.$picker = self._initDOM();

        // При клике за пределами допустимой области закрывать элемент.
        document.addEventListener('click', self._handleClickOutside, true);

        $('body').append(self.$picker);

        self.$picker.on('click', function (event) {
            var item = $(event.target).closest('.nrp-item');
            if (item.length)
                self._handleItemClicked(item);
        });

        self.$picker.on('mousemove', function (event) {
            if (!self.selecting)
                return;

            var $item = $(event.target).closest('.nrp-item');
            if ($item.length)
                self._handleItemHovered($item);
            else
                self._handleNoItemHover();
        });

        // Восстановить состояние выбранных элементов в UI.
        if (self.range)
            self._selectRange(self.range.min, self.range.max, !!raiseEvent);

        if (raiseEvent)
            $parent.trigger('show.numberrangepicker', [self]);
    };

    this.hide = function (raiseEvent) {
        if (self.$picker === null)
            return;

        document.removeEventListener('click', self._handleClickOutside, true);
        self._cleanSelection();
        self.$picker.remove();
        self.$picker = null;

        if (raiseEvent)
            $parent.trigger('hide.numberrangepicker', [self]);
    };

    this.toggle = function () {
        if (self.$picker === null)
            self.show(true);
        else
            self.hide(true);
    };

    this.getRange = function () {
        return range;
    };

    this._findItemElem = function (value) {
        return $('.nrp-item[data-value=' + value + ']', self.$picker);
    };

    this._findItemElemsInbetween = function (min, max) {
        return $('.nrp-item', self.$picker).filter(function () {
            var itemValue = $(this).data('value');
            return min < itemValue && itemValue < max;
        });
    };

    this._handleClickOutside = function (event) {
        var isWithinParent = $(event.target).closest(self.$parent).length > 0;
        var isWithinPicker = $(event.target).closest(self.$picker).length > 0;
        if (!isWithinParent && !isWithinPicker)
            self.hide();
    };

    this._handleItemClicked = function ($item) {
        var itemValue = parseInt($item.data('value'));

        if (!self._canCompleteSelection(itemValue)) {
            self._beginSelecting(itemValue);
        } else {
            self._completeSelection(itemValue);
        }
    };

    this._handleItemHovered = function ($item) {
        // Не обновлять интерфейс если наведенный элемент не изменился.
        if (self.$lastHoveredItem && self.$lastHoveredItem.is($item))
            return;

        self._setUiSelection(self.currentRangeStart, $item.data('value'), { preview: true });
        self.$lastHoveredItem = $item;
    };

    this._handleNoItemHover = function () {
        // Не обновлять интерфейс если наведенный элемент не изменился.
        if (!self.$lastHoveredItem)
            return;

        self._setUiSelection(self.currentRangeStart, null, { preview: true });
        self.$lastHoveredItem = null;
    };

    this._initDOM = function () {
        var children = [];

        for (var i = options.min; i <= options.max; ++i) {
            var item = $('<div class="nrp-item">').attr('data-value', i);
            var itemContent = options.renderItem.apply($parent, [i]);

            item.append(itemContent);
            children.push(item);
        }

        var header = $('<div class="nrp-header">').text(options.headerText);
        var itemContainer = $('<div class="nrp-items">')
            .append(children);

        var geometry = self._calcGeometry();
        var container = $('<div class="numberrangepicker">')
            .css('position', 'absolute')
            .css('top', geometry.top)
            .css('left', geometry.left)
            .css('right', 'auto')
            .append(header)
            .append(itemContainer);

        return container;
    };

    this._calcGeometry = function () {
        var clientRect = $parent.get(0).getBoundingClientRect();
        var height = $parent.outerHeight();
        return {
            left: clientRect.left,
            top: clientRect.top + document.documentElement.scrollTop + height,
        };
    };

    this._beginSelecting = function (min) {
        self._cleanSelection();
        self.currentRangeStart = parseInt(min);
        self._setUiSelection(min, null, { preview: true });
    };

    this._completeSelection = function (max) {
        if (!self._canCompleteSelection(max)) {
            console.warn('Bad selection range:', self.currentRangeStart, max);
            return;
        }

        var min = self.currentRangeStart;
        self._cleanSelection();
        self._selectRange(min, max, true);
        self.currentRangeStart = null;

        self.hide();
    };

    this._cleanSelection = function () {
        self.currentRangeStart = null;
        self.$lastHoveredItem = null;
    };

    this._canCompleteSelection = function (max) {
        // Если пользователь не начинал выделение или выбрал число ниже
        // текущего диапазона, выделение завершить невозможно.
        return self.currentRangeStart !== null && self.currentRangeStart <= parseInt(max);
    };

    this._selectRange = function (min, max, raiseEvent) {
        self._setUiSelection(min, max);
        self.range = { min: min, max: max };

        if (raiseEvent)
            $parent.trigger('apply.numberrangepicker', [{ min: min, max: max }, self]);
    };

    this._setUiSelection = function (min, max, options) {
        var isMinDefined = min !== undefined && min !== null
        var isMaxDefined = max !== undefined && max !== null;

        options = $.extend({}, options);
        min = isMinDefined ? parseInt(min) : null;
        max = isMaxDefined ? parseInt(max) : null;

        if (!isMinDefined && isMaxDefined) {
            console.error('Invalid range tuple:', min, max);
            return;
        }

        self._resetUiSelection();

        if (isMinDefined) {
            var $el = self._findItemElem(min);
            $el.addClass('nrp-active').addClass('nrp-range-start');
        }

        if (isMaxDefined) {
            var classes = !options.preview
                ? ['nrp-active', 'nrp-range-end']
                : ['nrp-preview', 'nrp-range-end'];
            var $el = self._findItemElem(max);

            for (var i = 0; i < classes.length; ++i)
                $el.addClass(classes[i]);
        }

        self.$picker.addClass(options.preview ? 'range-preview' : self.range ? 'range-selected' : null);

        // Подсветка промежуточных элементов.
        if (isMinDefined && isMaxDefined && min < max) {
            var $inbetween = self._findItemElemsInbetween(min, max);
            $inbetween.addClass('nrp-within-range');
        }
    };

    this._resetUiSelection = function () {
        var classes = [
            'nrp-active',
            'nrp-preview',
            'nrp-range-start',
            'nrp-range-end',
            'nrp-within-range'
        ];
        var $el = $('.nrp-item', self.$picker);

        for (var i = 0; i < classes.length; ++i)
            $el.removeClass(classes[i]);

        self.$picker.removeClass('range-selected').removeClass('range-preview');
    };

    this._init();
}

// Параметры по умолчанию.
const defaults = {
    'range': null,
    'min': 1,
    'max': 28,
    'renderItem': function (num) { return $('<span>').text(num); },
};

function sanitizeOptions(options) {
    if (options.range && (typeof options.range.min != 'number' || typeof options.range.max != 'number')) {
        console.error('Bad range:', options.range.min, options.range.max);
        options.range = null;
    }

    return options;
};

$.fn.numberrangepicker = function (op) {
    if (typeof op == 'object' || typeof op == 'undefined' || typeof op == 'null') {
        var options = sanitizeOptions($.extend(defaults, op));
        var instance = new NumberRangePicker(this, options);
        this.data('numberrangepicker', instance);

        return instance;
    } else if (typeof op == 'string' && op.toLowerCase() == 'numberrangepicker') {
        return this.data('numberrangepicker');
    }
}